import { render } from "./CategoriesHeader.vue?vue&type=template&id=5f25f7c6&scoped=true"
import script from "./CategoriesHeader.vue?vue&type=script&lang=js"
export * from "./CategoriesHeader.vue?vue&type=script&lang=js"

import "./CategoriesHeader.vue?vue&type=style&index=0&id=5f25f7c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f25f7c6"]])

export default __exports__